import { render, staticRenderFns } from "./Sermons.vue?vue&type=template&id=7bf0f290&scoped=true&"
import script from "./Sermons.vue?vue&type=script&lang=js&"
export * from "./Sermons.vue?vue&type=script&lang=js&"
import style0 from "./Sermons.vue?vue&type=style&index=0&id=7bf0f290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0f290",
  null
  
)

export default component.exports